// extracted by mini-css-extract-plugin
export var smallSpinner = "_qa-0";